import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedAccident } from "../../../../actions/accidentDashboard";
import {
  cleanConnectivityResponsesWithFilters,
  getConnectivityResponsesWithFilter,
} from "../../../../actions/connectivityResponse";
import { convertDateTimeToNet } from "../../../../utils/datetimeUtils";
import { StyledSearchContainer } from "../../../styled/connectivity";
import AccidentDashboardContainer from "../../accident/accidentDashboard/accidentDashboardContainer";
import Search from "./Search";
import SearchErroresConectividadTable from "./SearchConnectivityErrorsTable";

const initialSearchValues = {
  art: "",
  siniestro: "",
  dni: "",
  fechaDesde: null,
  fechaHasta: null,
  otrosPrestadores: false,
};

const SearchConnectivityErrorsContainer = () => {
  const dispatch = useDispatch();

  const respuestasConectividad = useSelector(
    (state) => state.connectivityResponse,
  );
  const [displayAccidents, setDisplayAccidents] = useState("block");
  const [searchFilters, setSearchFilters] = useState(initialSearchValues);

  useEffect(() => {
    dispatch(cleanConnectivityResponsesWithFilters());
    setSearchFilters(initialSearchValues);
  }, []);

  const handleFetchData = () => {
    if (searchFilters.fechaDesde != null && searchFilters.fechaHasta != null) {
      dispatch(getConnectivityResponsesWithFilter(searchFilters));
    }
  };

  const handleSearch = (values) => {
    const searchModel = {
      ...values,
      fechaDesde: values.fechaDesde
        ? convertDateTimeToNet(values.fechaDesde)
        : "",
      fechaHasta: values.fechaHasta
        ? convertDateTimeToNet(values.fechaHasta)
        : "",
    };

    setSearchFilters(searchModel);
    dispatch(getConnectivityResponsesWithFilter(searchModel));
  };

  const handleAccidentDetail = (accident) => {
    dispatch(
      setSelectedAccident({
        ...accident,
        idSiniestro: accident.siniestro,
        apellidoTrabajador: accident.trabajador,
      }),
    );
    setDisplayAccidents("none");
  };

  return (
    <StyledSearchContainer.Container>
      {displayAccidents === "none" && (
        <AccidentDashboardContainer setDisplayAccidents={setDisplayAccidents} />
      )}
      {displayAccidents !== "none" && (
        <>
          <StyledSearchContainer.Title>
            Buscar Respuestas Conectividad
          </StyledSearchContainer.Title>
          <Search
            handleSubmit={handleSearch}
            loading={
              respuestasConectividad.searchConnectivityResponses.isFetching
            }
            initialValues={initialSearchValues}
          />
        </>
      )}
      <SearchErroresConectividadTable
        data={
          respuestasConectividad.searchConnectivityResponses.data
            .searchRespuestaConectividadList || []
        }
        loading={respuestasConectividad.searchConnectivityResponses.isFetching}
        error={respuestasConectividad.searchConnectivityResponses.didInvalidate}
        fetchData={() => handleFetchData()}
        title="Respuestas Conectividad"
        handleOpenAccidentDetail={handleAccidentDetail}
        displayAccidents={displayAccidents}
      />
    </StyledSearchContainer.Container>
  );
};

export default SearchConnectivityErrorsContainer;
